export default __webpack_public_path__ + "static/media/step-1.46b2b4b3.png";